module.exports = __webpack_public_path__ + "static/media/35.287f4e77.webp";